module.exports = __webpack_public_path__ + "static/media/bank_blue.5cf2f75b.svg";